<script lang="jsx">
import { map } from '../lib'
import DropDown from './DropDown.vue'

const items = map(
  ['AU', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'IE', 'IT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SE', 'SK', 'UA', 'US'],
  (locale) => ({
    value: locale,
    label: locale === 'SE' ? 'SV' : locale,
  }),
)

const LocaleDropDown = ({ id, value, update, disabled, default: _default, required }) => {
  return (
    <DropDown
      label="Locale"
      id={id}
      value={value}
      update={update}
      disabled={disabled}
      default={_default}
      items={items}
      required={required}
    />
  )
}
export default LocaleDropDown
</script>
